module.exports = __webpack_public_path__ + "static/media/berry-veil.7f868a80.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/Landscape/berry-veil.jpg
// module id = 283
// module chunks = 0